module.exports = {"id":"190544","name":"Adem Ljajić","rating":"80","photo":"./data/images/photos/3/190544.png","club":{"name":"Torino","logo":"./data/images/clubs/Torino.png"},"positions":["MOC","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdemLjajic0.json
// module id = 95
// module chunks = 0